// extracted by mini-css-extract-plugin
module.exports = {"CurrentStaffCourse":"InputBookingTargetWithStaff_CurrentStaffCourse__3iSd5","CurrentStaffCourse__Menu":"InputBookingTargetWithStaff_CurrentStaffCourse__Menu__3Wkz4"};